import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "center",
  },
  box: {
    width: 44,
    height: 52,
  },
  input: {
    textAlign: "center",
    fontSize: 22,
    padding: 0,
    color: theme.palette.common.black,
  },
  notchedOutline: {
    borderColor: grey[300],
  },
}));
